export enum UserTypes {
    OWNER_OPERATOR_ADMIN = 'OWNER_OPERATOR_ADMIN',
    OwnerOperator = 'ownerOperator',
    Tenant = 'tenant',
    Unknown = 'unknown',
}
